var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#009B94"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14307 5.18848V11H6.71973V5.18848H8.14307ZM6.62305 3.66846C6.62305 3.45719 6.69466 3.28174 6.83789 3.14209C6.9847 3.00244 7.18164 2.93262 7.42871 2.93262C7.67578 2.93262 7.87093 3.00244 8.01416 3.14209C8.16097 3.28174 8.23438 3.45719 8.23438 3.66846C8.23438 3.87614 8.16097 4.0498 8.01416 4.18945C7.87093 4.3291 7.67578 4.39893 7.42871 4.39893C7.18164 4.39893 6.9847 4.3291 6.83789 4.18945C6.69466 4.0498 6.62305 3.87614 6.62305 3.66846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveInfo);
export default __webpack_public_path__ + "static/media/active-info.a629e227b80e3f3c6b7c20f0a027b2c1.svg";
export { ForwardRef as ReactComponent };